import { createRouter, createWebHistory } from "vue-router";

//rmsons
import Game from "../views/game/Game.vue"
import Package from "../views/package/Package"
import Payment from "../views/payment/Payment"
import Terms from "../views/payment/step/Terms.vue"
import Registration from '../views/users/Registration.vue'
import Login from '../views/users/Login.vue'
import Thankyou from '../views/payment/step/Thankyou.vue'

// Management
import GameManagement from '../views/management/stock/Game.vue'
import PackageManagement from '../views/management/stock/Package.vue'
import UserManagement from '../views/management/user/User.vue'
import UserDetail from '../views/management/user/UserDetail.vue'
import AppConfig from '../views/management/app/AppConfig.vue'
import WalletManagement from "../views/management/wallet/Wallet.vue";
import AgentManagement from '../views/management/agent/Agent.vue'
import BenefitGameTopup from '../views/management/agent/BenefitGameTopup.vue'
import BankStatement from '../views/management/bank/BankStatement.vue'

// Order
import PurchaseDetails from '../views/purchase/PurchaseDetails.vue'
import PurchaseHistory from '../views/purchase/PurchaseHistory.vue'
import SaleDashboard from "../views/dashboard/SaleDashboard.vue";
import StockDashboard from "../views/dashboard/StockDashboard.vue";

// Wallet
import Wallet from "../views/wallet/Wallet.vue";

import DashboardLayout from "../views/dashboard/layout/DashboardLayout.vue";

// Page Headers
import DefaultHeader from "../views/dashboard/headers/DefaultHeader";

// GeneralViews
import NotFound from "../views/generalViews/NotFoundPage.vue";

const routes = [
  {
    path: "/",
    redirect: "/game",
    name: "Home",
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard",
    children: [
      {
        path: "game",
        name: "Game Choose",
        components: { default: Game, header: DefaultHeader },
      },
      {
        path: "game/:code",
        name: "Package Choose",
        props: true,
        components: { default: Package, header: DefaultHeader },
      },
      {
        path: "payment",
        name: "Payment",
        components: { default: Payment, header: DefaultHeader },
      },
      {
        path: "terms",
        name: "Terms",
        components: { default: Terms, header: DefaultHeader },
      },
      {
        path: "registration",
        name: "Registration",
        components: { default: Registration, header: DefaultHeader },
      },
      {
        path: "login",
        name: "Login",
        components: { default: Login, header: DefaultHeader },
      },
      {
        path: "thankyou",
        name: "Thank you",
        components: { default: Thankyou, header: DefaultHeader },
      },
      {
        path: "management/game",
        name: "Game Stock Management",
        components: { default: GameManagement, header: DefaultHeader },
      },
      {
        path: "management/package/:id",
        name: "Package Stock Management",
        components: { default: PackageManagement, header: DefaultHeader },
      },
      {
        path: "management/user",
        name: "User Management",
        components: { default: UserManagement, header: DefaultHeader },
      },
      {
        path: "user/:id",
        name: "User Details",
        components: { default: UserDetail, header: DefaultHeader },
      },
      {
        path: "management/appconfig",
        name: "App Config",
        components: { default: AppConfig, header: DefaultHeader },
      },
      {
        path: "management/wallet",
        name: "Wallet Management",
        components: { default: WalletManagement, header: DefaultHeader },
      },
      {
        path: "purchase/history",
        name: "Purchase History",
        components: { default: PurchaseHistory, header: DefaultHeader },
      },
      {
        path: "management/history",
        name: "Management Purchase History",
        components: { default: PurchaseHistory, header: DefaultHeader },
      },
      {
        path: "purchase/details/:id",
        name: "Purchase Details",
        components: { default: PurchaseDetails, header: DefaultHeader },
      },
      {
        path: "management/details/:id",
        name: "Management Purchase Details",
        components: { default: PurchaseDetails, header: DefaultHeader },
      },
      {
        path: "dashboard/sale",
        name: "Sales Dashboard",
        components: { default: SaleDashboard, header: DefaultHeader },
      },
      {
        path: "dashboard/stock",
        name: "Stock Dashboard",
        components: { default: StockDashboard, header: DefaultHeader },
      },
      {
        path: "wallet",
        name: "My Wallet",
        components: { default: Wallet, header: DefaultHeader },
      },
      {
        path: "management/agent",
        name: "Agent Management",
        components: { default: AgentManagement, header: DefaultHeader },
      },
      {
        path: "management/benefitgametopup",
        name: "Agent Benefit Management",
        components: { default: BenefitGameTopup, header: DefaultHeader },
      },
      {
        path: "management/bankstatement",
        name: "Bank Statement Management",
        components: { default: BankStatement, header: DefaultHeader },
      }

    ],
  },
  { path: "/:pathMatch(.*)*", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  beforeEach: ((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
      if (firebase.auth().currentUser) {
        next();
      } else {
        alert('You must be logged in to see this page');
        next({
          path: '/dashboard',
        });
      }
    } else {
      next();
    }
  }),
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      };
    }
    return { x: 0, y: 0 };  // Go to the top of the page if no hash
  },
  routes,
});

export default router;
